import Swiper, { Pagination, Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

const init = (wrapper) => {
  const carousel = wrapper.querySelector('.js-quote-callout-carousel')
  const slides = carousel.querySelectorAll('.swiper-slide')

  if (slides.length <= 1) {
    return
  }

  return new Swiper(carousel, {
    modules: [
      Pagination,
      Autoplay
    ],
    cssMode: false,
    slidesPerView: 1,
    loop: true,
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    }
  })
}

export default () => {
  document.querySelectorAll('.js-quote-callout').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}